import axios from './axios';

export const getStates = async () => {
    try {
        const response = await axios.get(`/locality/states`);
        // console.log(response.data)
        return response.data;
    } catch (error) {
        return error.response.data;
    }
}

export const getCityId = async (params) => {
    try {
        const response = await axios.get(`/locality/cities?state=${params}`);
        // console.log(response.data)
        return response.data;
    } catch (error) {
        return error.response.data;
    }
}

// !---------------- register user -----------------
export const registerUser = async (params,formData) => {
    try {
        // console.log("formData",formData)
        const response = await axios.post(`/auth/customer/register?${params}`, formData);
        return response.data;
    } catch (error) {
        return error.response.data;
    }
}
// !---------------- update user -----------------
export const updateUserInfo = async (params,formData) => {
    try {
        const response = await axios.post(`/user/update?${params}`, formData,
            {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            }
        );
        return response.data;
    } catch (error) {
        return error.response.data;
    }
}
// !---------------- update password -----------------
export const updateUserPassword = async (data) => {
    try {
        const response = await axios.post('/user/update-password', data);
        return response.data;
    } catch (error) {
        return error.response.data;
    }
}
// !---------------- register user -----------------
export const loginUser = async (params) => {
    try {
        const response = await axios.post(`/auth/customer/login?${params}`);
        // console.log(response)
        return response
    } catch (error) {
        return error
    }
}
// !---------------- forgot password -----------------
export const forgotPassword = async (data) => {
    try {
        const response = await axios.post('/auth/forgot-password', data);
        return response.data;
    } catch (error) {
        return error.response.data;
    }
}
// !---------------- User Info -----------------
export const getUserInfo = async () => {
    try {
        const response = await axios.get('/user/show');
        return response.data;
    } catch (error) {
        return error.response.data;
    }
}

// !---------------- logout -----------------
export const LogOut=async ()=>{
    try {
        const response = await axios.post('/auth/logout');
        return response.data;
    } catch (error) {
        return error.response.data;
    }
}